function isNullOrWhiteSpace(value?: string | number): boolean {
    // prefilled value of yearlyFrom and yearlyTo from going back is number, once filled will be turned back to string
    return !value || value.toString().trim() === '';
}

function resetEmptyStringToNull(value?: string | null): string | null {
    if (value === '' || value === undefined) {
        return null;
    }

    return value;
}

export { isNullOrWhiteSpace, resetEmptyStringToNull };
